<template>
  <NuxtLayout>
    <NuxtPage />
    <client-only>
      <noscript>
        <iframe
          src="https://www.googletagmanager.com/ns.html?id=GTM-54L9GCJM"
          height="0"
          width="0"
          style="display:none;visibility:hidden"
        ></iframe>
      </noscript>
    </client-only>
  </NuxtLayout>
</template>
<script lang="ts" setup>

  useHead({
    link: [
      { rel: 'icon', type: 'image/png', href: '/favicon.ico' },
      { rel: 'apple-touch-icon', href: '/favicon.ico' }
    ],
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1, viewport-fit=cover' }
    ]
  })

  useTheme()
  
</script>


